import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2ce980cb&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2ce980cb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce980cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ce980cb')) {
      api.createRecord('2ce980cb', component.options)
    } else {
      api.reload('2ce980cb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2ce980cb&scoped=true", function () {
      api.rerender('2ce980cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/gridTable/index.vue"
export default component.exports